<app-loader [isLoading]="isLoading"></app-loader>
<div class="container-oblate">
  <!-- <div class="d-flex justify-content-between heading-div">
    @if(!isMobileDevice){ <span class="headingText">Oblate Register</span>}
    <div class="d-flex btn-div flex-end"> -->
  <!-- button hidden -->
  <!-- <button class="addButton dp-primary-btn" (click)="onAddNewClick()">
        <img src="../../../../assets/images/plus-icon.svg" />
        @if(!isMobileDevice){
        <span class="textContent">Add Oblate</span>}
      </button> -->
  <!-- @if(!isMobileDevice){
      <button class="addButton dp-secondary-btn" (click)="onCountClick()">
        <span class="textContent">Show Count</span>
      </button>

      } -->
  <!-- </div>
  </div>
  <app-dp-tab-menu></app-dp-tab-menu>
  <app-dp-tab-menu-v3></app-dp-tab-menu-v3>-->

  <!-- @if (!isMobileDevice) { -->
  <div class="oblate-header">
    @if (!isMobileDevice) {
        <span class="headingText">Oblate Register</span>
      }
    <div class="oblate-heder-section">    
      <form>
        <div class="searchContainer" >
          <div class="d-flex gap-4">
            <input class="search-input dp-input-control" type="text" [formControl]="searchReq"
              placeholder="Search by any column" aria-label="Search" />
            <!-- <div class="manage-user-button-group"> -->
            <button class="filter-button dp-primary-btn" (click)="onFilterClick()">
              @if(!isMobileDevice){
              <h1 class="filter-button-text">Filter</h1>
              }
              <div class="logo-filter"></div>
              <!-- <img src="assets/filter.svg" /> -->
            </button>
          </div>
          <button class="dp-secondary-btn" style="height: 40px;" (click)="fetchAllData()">
            <span class="textContent">Save as PDF</span>
          </button>
        </div>
      </form>

      @if (!isMobileDevice) {
      <div class="diksha-btn-row">
        @if(isAbleToAddDPOnline){
          <button type="button" class="dp-secondary-btn" style="height: 40px;" (click)="onClickAddOblate('online')"
            (mouseenter)="showOnlineMessage = true" (mouseleave)="showOnlineMessage = false">
            <span class="textContent">+ New diksha (Online)</span>
          </button>
        }

        @if(isAbleToAddDPOffline){
          <button type="button" class="dp-secondary-btn" style="height: 40px;" (click)="onClickAddOblate('offline')"
            (mouseenter)="showOfflineMessage = true" (mouseleave)="showOfflineMessage = false">
            <span class="textContent">+ Upload DP (Offline)</span>
          </button>
        }
      
      

      @if (showOnlineMessage) {
      <div class="add-oblate-description">This method is only applicable for real-time initiations. Please check before
        proceeding!</div>
      }

      @if (showOfflineMessage) {
      <div class="add-oblate-description">This method is to upload diksha patras of the ongoing term.</div>
      }
      </div>
    }
    </div>    
  </div>
  <!-- } -->

  @if(isMobileDevice && (isAbleToAddDPOffline || isAbleToAddDPOnline)) {
    <div class="add-oblate-btn">
      <button type="button" class="dp-primary-btn" style="height: 40px;" (click)="onClickAddOblateForMobile()">
        <span class="textContent">+ Add Oblate</span>
      </button>
    </div>
    
  }

  <div class="d-flex flex-column content">
    <!-- <div class="separator-div"></div> -->
    <div class="d-flex count-div">
      <div class="details">
        <span class="details-heading">Total dikshya</span>
        <div class="count-dtls d-flex justify-content-between">
          <span class="count">{{countDetails.TotalRecords || 0}}</span>

        </div>
      </div>
      <div class="details">
        <span class="details-heading">Active</span>
        <div class="count-dtls d-flex justify-content-between">
          <span class="count">{{countDetails.TotalActiveRecords || 0}}</span>

        </div>
      </div>
      <div class="details">
        <span class="details-heading">Inactive</span>
        <div class="count-dtls d-flex justify-content-between">
          <span class="count">{{countDetails.TotalInactiveRecords ||0}}</span>

        </div>
      </div>
      <div class="details">
        <span class="details-heading">Active percentage</span>
        <div class="count-dtls d-flex justify-content-between">
          <span class="count">{{(countDetails.TotalActiveRecords / (countDetails.TotalRecords) | percent) || '0%'}}</span>
        </div>
      </div>
      
      
      <!-- <div class="details">
        <span class="details-heading">Total Diksha</span>
        <span class="details-sub-heading">(From Jan1, 2024 - {{lastRefreshedDate}})</span>
        <div class="count-dtls d-flex justify-content-between">
          <span class="count">{{countDetails.totalDiksha || 0}}</span>

        </div>
      </div>
      <div class="details">
        <span class="details-heading">No of working days</span>
        <span class="details-sub-heading">(From Jan1, 2024 - {{lastRefreshedDate}})</span>
        <div class="count-dtls d-flex justify-content-between">
          <span class="count">{{countDetails?.workingDays || 0}}</span>

        </div>
      </div> -->
    </div>
    <!-- <div class="separator-div" style="margin-bottom: 16px"></div> -->
  </div>
  @if(!isMobileDevice){ @if(isLoader){
  <table class="dp-table">
    <thead class="dp-table-header">
      <tr>
        <th>Sl.no</th>
        <th>Status</th>

        <th>Name</th>
        <th>Guardian</th>
        <th>Contact</th>
        <th>Initiation Date</th>
        <th>Ritwik</th>
        <th>Pin</th>
        <th>Adress</th>
      </tr>
    </thead>
    <tbody class="dp-table-body">
      <tr *ngFor="let i of [].constructor(20)">
        <td *ngFor="let j of [].constructor(9)">
          <dp-loader></dp-loader>
        </td>
      </tr>
    </tbody>
  </table>
  }@else{
  <div class="dp-table-scroll" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="1000" (scrolled)="onScroll()" #tableContainer>
    <dp-table [dataTable]="oblateData" [displayedColumns]="displayColumnData"
      [componentMap]="cellComponentMap"></dp-table>
  </div>
  } } @else{

  <div class="dataList">
    @if(isLoader){
    <div *ngFor="let i of [].constructor(10)">
      <ul class="eachdataList">
        <li class="data">
          Sl.No
          <div class="loader-div"><dp-loader></dp-loader></div>
        </li>
        <li class="data">
          Status
          <div class="loader-div"><dp-loader></dp-loader></div>
        </li>

        <li class="data">
          Name
          <div class="loader-div"><dp-loader></dp-loader></div>
        </li>
        <li class="data">
          Guardian
          <div class="loader-div"><dp-loader></dp-loader></div>
        </li>
        <li class="data">
          Contact
          <div class="loader-div"><dp-loader></dp-loader></div>
        </li>
        <li class="data">
          Initiation date
          <div class="loader-div"><dp-loader></dp-loader></div>
        </li>
        <li class="data">
          Ritwik
          <div class="loader-div"><dp-loader></dp-loader></div>
        </li>
        <li class="data">
          Pincode
          <div class="loader-div"><dp-loader></dp-loader></div>
        </li>
        <li class="data">
          Address
          <div class="loader-div"><dp-loader></dp-loader></div>
        </li>
      </ul>
    </div>
    }@else { @for( lists of oblateData; track lists){

    <div class="dp-table-scroll" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="1000" (scrolled)="onScroll()">
      <!-- @for( lists of oblateData; track lists){ -->
      <ul class="eachdataList">
        <li class="data">
          Sl.No
          <span class="serial-no">{{ lists.mk }}</span>
        </li>
        <li class="data">
          Status<span>{{ lists.status }}</span>
        </li>

        <li class="data">
          Name <span>{{ lists.fullName }}</span>
        </li>
        <li class="data">
          Guardian <span>{{ lists.guardianName }}</span>
        </li>
        <li class="data">
          Contact <span>{{ lists.mob }}</span>
        </li>
        <li class="data">
          Initiation date <span>{{ lists.md }}</span>
        </li>
        <li class="data">
          Ritwik <span>{{ lists.rn }}</span>
        </li>
        <li class="data">
          Pincode <span>{{ lists.pn }}</span>
        </li>
        <li class="data">
          Address <span>{{ lists.add }}</span>
        </li>
      </ul>
      <!-- } -->
    </div>
    } }
  </div>
  }
</div>